export default "__VITE_ASSET__DlCoHwdq__"